import { Banknote, Building2, Folder } from 'lucide-react'
import { cn } from '../../lib/utils'
import { UserIcon } from '../ui'

function FallbackGroupIcon({ className }: { className?: string }) {
  return <Folder className={cn('w-4 h-4 text-gray-500', className)} />
}

function FallbackCompanyIcon({ className }: { className?: string }) {
  return <Building2 className={cn('w-4 h-4 text-gray-500', className)} />
}

function FallbackUserIcon({ className }: { className?: string }) {
  return <UserIcon className={cn('w-4 h-4 text-gray-500', className)} />
}

function FallbackMsbIcon({ className }: { className?: string }) {
  return <Banknote className={cn('w-4 h-4 text-gray-500', className)} />
}

export { FallbackGroupIcon, FallbackCompanyIcon, FallbackUserIcon, FallbackMsbIcon }
